import api from "../../utils/aixos";

export const cancelSubscriptionApiCall = async () =>
  api.post("payment/cancel-subscription");

export const updatePaymentMethodApiCall = async (paymentMethod: string) =>
  api.post("payment/update-subscription", { paymentMethod });
